import { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { AiFillLayout, AiFillWarning } from 'react-icons/ai'
import { AdminUser } from '../../../../API/AdminInfo/models'
import toast from 'react-hot-toast'
import Swal from 'sweetalert2'
import { updateAdminInfo } from '../../../../API/AdminInfo/AdminInfo'

interface ConfigPanelProps {
    adminInfo: AdminUser | null;
}

export const ConfigPanel = ({ adminInfo }: ConfigPanelProps) => {
    const [showChangePassword, setShowChangePassword] = useState(false)
    const [formData, setFormData] = useState({
        nickname: '',
        panel_password: '',
        newPanelPassword: '',
        panel_password_repeat: ''
    })

    const handleInputValues = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleCancelChangePw = () => {
        setShowChangePassword(false)
    }

    const submitForm = async () => {
        const payload: {
            panel_password?: string,
            newPanelPassword?: string,
        } = {}


        if (formData.newPanelPassword) {
            if (formData.panel_password_repeat !== formData.newPanelPassword) {
                toast.error('Las contraseñas no coinciden')
                return;
            }
            payload.newPanelPassword = formData.newPanelPassword
            payload.panel_password = formData.panel_password
        }

        let apiResponse = await updateAdminInfo(payload);

        if (apiResponse?.response?.data?.msg === 'Bad panel password') {
            toast.error('Contraseña del panel actual incorrecta.')
            return;
        };


        if (apiResponse?.response?.status === 400) {
            toast.error('Ha habido un error. Intenta de nuevo')
            return;
        };

        toast.success('Actualizado correctamente')
        setFormData({
            ...formData,
            panel_password: '',
            panel_password_repeat: '',
            newPanelPassword: '',
        })
        setShowChangePassword(false);
    }

    useEffect(() => {
        if (adminInfo?.id) {
            setFormData({
                ...formData,
                nickname: adminInfo.nickname,
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adminInfo])

    return (
        <div className='w-100'>
            <Card className='p-md-5 p-4 shadow-sm'>
                <div className='d-flex align-items-center gap-3 mb-4'>
                    <AiFillLayout size={24} className="text-primary" />
                    <div>
                        <h5 className="mb-1 text-primary">Configuración del Panel</h5>
                        <p className='text-secondary mb-0' style={{ fontSize: '14px' }}>
                            Configuración de todo lo relacionado al panel de la plataforma y el acceso externo a la misma.
                        </p>
                    </div>
                </div>

                <div className="mt-4">
                    <div className='mb-4'>
                        <label className='text-sm text-primary fw-semibold'>
                            Nombre del Panel
                            <span className='text-secondary ms-2' style={{ fontSize: '12px' }}>
                                (No se puede modificar)
                            </span>
                        </label>
                        <input
                            name='nickname'
                            disabled
                            onChange={handleInputValues}
                            className='form-control w-50'
                            value={formData.nickname}
                        />
                    </div>

                    {showChangePassword && (
                        <div className='mt-4 rounded-3'>
                            <div className='mb-3'>
                                <label className='form-label'>Contraseña actual del panel <span className="text-danger">*</span></label>
                                <input
                                    autoComplete="off"
                                    name='panel_password'
                                    onChange={handleInputValues}
                                    type='password'
                                    className='form-control'
                                    value={formData.panel_password}
                                />
                            </div>

                            <div className='mb-3'>
                                <label className='form-label'>Nueva contraseña del panel <span className="text-danger">*</span></label>
                                <input
                                    autoComplete="off"
                                    name='newPanelPassword'
                                    onChange={handleInputValues}
                                    type='password'
                                    className='form-control'
                                    value={formData.newPanelPassword}
                                />
                            </div>

                            <div className='mb-3'>
                                <label className='form-label'>Repetir nueva contraseña <span className="text-danger">*</span></label>
                                <input
                                    autoComplete="off"
                                    name='panel_password_repeat'
                                    onChange={handleInputValues}
                                    type='password'
                                    className='form-control'
                                    value={formData.panel_password_repeat}
                                />
                            </div>

                            <div className='alert alert-warning d-flex align-items-center gap-3 mt-4'>
                                <AiFillWarning size={24} />
                                <p className='mb-0' style={{ fontSize: '14px' }}>
                                    El nombre y la contraseña deben ser exactamente las mismas (verifica minúsculas y mayúsculas) que se utilizan para entrar al panel principal, de otra forma el bot NO PODRÁ acceder a él, y no habrá ninguna acción disponible.
                                </p>
                            </div>

                        </div>

                    )}



                    <div className='d-flex justify-content-between align-items-center mt-4 pt-3'>
                        {!showChangePassword ? (
                            <button className='btn btn-dark' onClick={() => setShowChangePassword(true)}>
                                Cambiar contraseña del panel
                            </button>
                        ) : (
                            <button className='btn btn-secondary' onClick={handleCancelChangePw}>
                                Cancelar
                            </button>
                        )}
                        <button className='btn btn-primary px-4' onClick={submitForm}>
                            Guardar cambios
                        </button>
                    </div>
                </div>
            </Card>
        </div>
    )
}
